import React, { useState, useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import html2pdf from "html2pdf.js";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

import {
    list
  } from "../../../../controllers/V1/invoice/invoiceControllers";
import PreviewPopup  from "../preview";
const Invoice = () => {
    const { batch_id } = useParams();
    const printRef = useRef();
    const hiddenPrintRef = useRef();
    const [isLoading, setIsLoading] =useState(true);
    const [ALLLISTDATA, setListData] = useState([]);
    const [downloadProgress, setDownloadProgress] = useState(0);

    /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          batch_no : batch_id, status : 'Completed'
        },
        select: {},
        sort: { _id: -1 },
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
        } else {
          setListData([]);
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

    // const generatePdf = async () => {
    //     const element = printRef.current;
    //     const options = {
    //         margin      : .25,
    //         filename    : "example.pdf",
    //         image       : { type: "jpeg", quality: 1 },
    //         html2canvas : { dpi: 1200, letterRendering: true, scale: 3 },
    //         jsPDF       : { unit: "in", format: [8.5, 11], orientation: "portrait" }
    //     };
    //     html2pdf().from(element).set(options).save();
    // };

    const downloadAllPdfsAsZip = async () => {
        if (ALLLISTDATA.length === 0) {
            alert('No invoices to download');
            return;
        }

        setIsLoading(true);
        setDownloadProgress(0);
        const zip = new JSZip();
        
        try {
            // For each invoice, render it in the hidden div and generate PDF
            for (let i = 0; i < ALLLISTDATA.length; i++) {
                const item = ALLLISTDATA[i];
                setDownloadProgress(Math.round(((i + 1) / ALLLISTDATA.length) * 100));

                // Render the invoice in the hidden div
                // We'll use a stateful approach: render all invoices, but only one is visible at a time for PDF
                const invoiceNode = hiddenPrintRef.current.querySelector(`#hidden-invoice-${i}`);
                if (!invoiceNode) continue;

                // Wait for the component to render and images to load
                await new Promise(resolve => setTimeout(resolve, 1000));

                // Generate PDF
                const options = {
                    margin: 0.25,
                    image: { type: "jpeg", quality: 1 },
                    html2canvas: { 
                        dpi: 1200, 
                        letterRendering: true, 
                        scale: 3,
                        useCORS: true,
                        allowTaint: true
                    },
                    jsPDF: { unit: "in", format: [8.5, 11], orientation: "portrait" }
                };
                const pdf = await html2pdf().from(invoiceNode).set(options).outputPdf('blob');
                const fileName = `invoice_${item?.pos_number || item?.invoice_no || item._id || `batch_${batch_id}_${i + 1}`}.pdf`;
                zip.file(fileName, pdf);
                if (i < ALLLISTDATA.length - 1) {
                    await new Promise(resolve => setTimeout(resolve, 200));
                }
            }
            const zipBlob = await zip.generateAsync({ type: 'blob' });
            const zipFileName = `invoices_batch_${batch_id}_${moment().format('YYYY-MM-DD_HH-mm-ss')}.zip`;
            saveAs(zipBlob, zipFileName);
        } catch (error) {
            console.error('Error generating zip:', error);
            alert('Error generating zip file. Please try again.');
        } finally {
            setIsLoading(false);
            setDownloadProgress(0);
        }
    };

    useEffect(()=>{
        getList();
    },[]);
    
  return (
  <div>
    {/* Download Button */}
    <div style={{ marginBottom: '20px', textAlign: 'center' }}>
      <button 
        onClick={downloadAllPdfsAsZip}
        disabled={isLoading || ALLLISTDATA.length === 0}
        style={{
          padding: '10px 20px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: isLoading || ALLLISTDATA.length === 0 ? 'not-allowed' : 'pointer',
          opacity: isLoading || ALLLISTDATA.length === 0 ? 0.6 : 1,
          fontSize: '16px',
          fontWeight: 'bold'
        }}
      >
        {isLoading ? `Generating ZIP... ${downloadProgress}%` : `Download All PDFs (${ALLLISTDATA.length} invoices)`}
      </button>
      {/* Progress Bar */}
      {isLoading && downloadProgress > 0 && (
        <div style={{ marginTop: '10px', width: '100%', maxWidth: '400px', margin: '10px auto' }}>
          <div style={{ 
            width: '100%', 
            backgroundColor: '#e0e0e0', 
            borderRadius: '10px', 
            overflow: 'hidden',
            height: '20px'
          }}>
            <div style={{ 
              width: `${downloadProgress}%`, 
              backgroundColor: '#28a745', 
              height: '100%', 
              transition: 'width 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '12px',
              fontWeight: 'bold'
            }}>
              {downloadProgress}%
            </div>
          </div>
        </div>
      )}
    </div>
    {/* Hidden Invoices for PDF Generation */}
    <div ref={hiddenPrintRef} style={{ position: 'absolute', left: '-9999px', top: 0, width: '8.5in', zIndex: -1 }}>
      {ALLLISTDATA.map((items, index) => (
        <div key={index} id={`hidden-invoice-${index}`}>
          <PreviewPopup nextInvoice={false} invoiceData={items} />
        </div>
      ))}
    </div>
    {/* Loading and Empty States */}
    {isLoading && (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <div>Loading invoices...</div>
      </div>
    )}
    {!isLoading && ALLLISTDATA.length === 0 && (
      <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
        <div>No invoices found for this batch.</div>
      </div>
    )}
    {/* Invoice List */}
    {!isLoading && ALLLISTDATA.length > 0 && (
      <div ref={printRef}>
        {ALLLISTDATA.map((items, index) => (
          <div key={index}>
            <PreviewPopup nextInvoice={false} invoiceData={items} />
            <br/>
          </div>
        ))}
      </div>
    )}
  </div>);
};

export default Invoice;
